<template>
  <transition name="fade">
    <div class="w-100">
      <div v-if="stage">
        <span class="h5 text-dark font-weight-bold d-block">
          Step {{ stage.step - (progress ? 0 : 1) }} of {{ totalSteps - (progress ? 0 : 1) }}
        </span> 
        <span class="text-secondary small mb-3 d-block">
          {{ stage.label }} ...
        </span>
      </div>
      <div 
        v-else 
        class="text-muted h5"
      >
        Preparing...
      </div>
      <div
        class="progress"
        style="height: 20px; border-radius: 10px;"
      >
        <div
          class="progress-bar bg-primary"
          role="progressbar"
          :style="{ width: progressPercent + '%' }"
          :aria-valuenow="progressPercent"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ progressPercent }}%
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('psdLayers');

const STAGE = {
  FETCHING_FILE: 0,
  PARSING_FILE: 1,
  BUILDING_LAYERS: 2,
  APPLYING_MASKS: 3,
};

const STAGES = {
  [STAGE.FETCHING_FILE]: { label: 'Fetching file', step: 1 },
  [STAGE.PARSING_FILE]: { label: 'Parsing file', step: 2 },
  [STAGE.BUILDING_LAYERS]: { label: 'Building layers', step: 3 },
  [STAGE.APPLYING_MASKS]: { label: 'Applying masks', step: 4 },
};

export default {
  name: 'ParseProgress',
  computed: {
    ...mapGetters(['parseProgress', 'progress']),
    stage() {
      if (!this.parseProgress) {
        if (this.progress) {
          return STAGES[STAGE.FETCHING_FILE];
        } else {
          return null;
        }
      }
      
      return STAGES[this.parseProgress.stage] || null;
    },
    totalSteps() {
      return Math.max(...Object.values(STAGES).map(s => s.step));
    },
    stepSize() {
      return 100 / this.totalSteps;
    },
    progressPercent() {
      if (!this.parseProgress) {
        return this.progress ? Math.floor(this.progress * this.stepSize) : 0;
      }

      const currentStage = this.stage;
      if (!currentStage) return 0;

      const data = this.parseProgress.data || {};
      let stageProgress = 0;

      switch (this.parseProgress.stage) {
        case STAGE.FETCHING_FILE: {
          stageProgress = data.progress || 0;
          break;
        }
        case STAGE.PARSING_FILE: {
          stageProgress = 0;
          break;
        }
        case STAGE.BUILDING_LAYERS: {
          const { totalNodes, builtNodes } = data;
          stageProgress = totalNodes ? (builtNodes || 0) / totalNodes : 1;
          break;
        }
        case STAGE.APPLYING_MASKS: {
          const { totalMasks, appliedMasks } = data;
          stageProgress = totalMasks ? (appliedMasks || 0) / totalMasks : 1;
          break;
        }
        default:
          stageProgress = 0;
      }

      return this.calcStageProgress(currentStage.step, stageProgress);
    },
  },
  methods: {
    calcStageProgress(step, stageProgress) {
      const min = (step - 1) * this.stepSize;
      const max = step * this.stepSize;
      return Math.min(max, min + Math.floor(stageProgress * this.stepSize));
    },
  },
};
</script>
